module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quickview-wrapper",
    attrs: {
      "id": "quickview",
      "data-pages": "quickview"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in no-padding",
    attrs: {
      "id": "quickview-notes"
    }
  }, [_c('Notes')], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade no-padding",
    attrs: {
      "id": "quickview-alerts"
    }
  }, [_c('Alerts')], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in active no-padding",
    attrs: {
      "id": "quickview-chat"
    }
  }, [_c('Chat')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {}, [_c('a', {
    attrs: {
      "href": "#quickview-notes",
      "data-toggle": "tab"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#quickview-alerts",
      "data-toggle": "tab"
    }
  }, [_vm._v("Alerts")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#quickview-chat",
      "data-toggle": "tab"
    }
  }, [_vm._v("Chat")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn-link quickview-toggle",
    attrs: {
      "data-toggle-element": "#quickview",
      "data-toggle": "quickview"
    }
  }, [_c('i', {
    staticClass: "pg-close"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ee83e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/quick_view.vue
// module id = 1363
// module chunks = 1